import { statusTone } from "@/lib/utils-format";

const TONE_CLASSES = {
  secondary: "bg-secondary/15 text-secondary border-secondary/30",
  primary: "bg-primary/15 text-primary border-primary/30",
  accent: "bg-accent/20 text-amber-700 dark:text-amber-300 border-accent/30",
  destructive: "bg-destructive/15 text-destructive border-destructive/30",
  muted: "bg-muted text-muted-foreground border-border",
};

export default function StatusPill({ status, className = "" }) {
  const tone = statusTone(status);
  return (
    <span
      data-testid={`status-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${TONE_CLASSES[tone]} ${className}`}
    >
      {status}
    </span>
  );
}
